import m from "../../geodata/es2015/moroccoLow";
window.am4geodata_moroccoLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/moroccoLow.js
// module id = null
// module chunks = 